import { MDSButton, MDSButtonVariant } from "@/mds/components/buttons/button";
import { MDSCalendarCell } from "@/mds/components/date-time/calendars/calendar-cell";
import { MDSCalendarGrid } from "@/mds/components/date-time/calendars/calendar-grid";
import { MDSCalendarGridBody } from "@/mds/components/date-time/calendars/calendar-grid-body";
import { MDSCalendarGridHeader } from "@/mds/components/date-time/calendars/calendar-grid-header";
import { MDSCalendarHeaderCell } from "@/mds/components/date-time/calendars/calendar-header-cell";
import { MDSCalendarHeading } from "@/mds/components/date-time/calendars/calendar-heading";
import {
  StyledCalendar,
  StyledHeader,
} from "@/mds/components/date-time/calendars/calendar/calendar.style";
import { IMDSCalendarProps } from "@/mds/components/date-time/calendars/calendar/calendar.types";
import { MDSIcon, MDSIconKind } from "@/mds/components/icon";

export const MDSCalendar = (props: IMDSCalendarProps) => {
  const { ariaLabel, weekdayStyle, ...rest } = props;

  return (
    <StyledCalendar aria-label={ariaLabel} {...rest}>
      <StyledHeader>
        <MDSButton slot="previous" variant={MDSButtonVariant.Transparent}>
          <MDSIcon kind={MDSIconKind.AngleLeft} />
        </MDSButton>
        <MDSCalendarHeading />
        <MDSButton slot="next" variant={MDSButtonVariant.Transparent}>
          <MDSIcon kind={MDSIconKind.AngleRight} />
        </MDSButton>
      </StyledHeader>

      <MDSCalendarGrid weekdayStyle={weekdayStyle}>
        <MDSCalendarGridHeader>
          {day => <MDSCalendarHeaderCell>{day}</MDSCalendarHeaderCell>}
        </MDSCalendarGridHeader>
        <MDSCalendarGridBody>{date => <MDSCalendarCell date={date} />}</MDSCalendarGridBody>
      </MDSCalendarGrid>
    </StyledCalendar>
  );
};
